import { render } from "./IrrAndIav.vue?vue&type=template&id=0e2ad676&scoped=true&ts=true"
import script from "./IrrAndIav.vue?vue&type=script&lang=ts"
export * from "./IrrAndIav.vue?vue&type=script&lang=ts"

import "./IrrAndIav.vue?vue&type=style&index=0&id=0e2ad676&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e2ad676"]])

export default __exports__